var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"page-title"},[_c('h1',{staticClass:"title"},[_vm._t("default")],2),_c('div',{staticClass:"button-place"},[_vm._t("menu"),_vm._t("button")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }